<div *ngIf="confImageValue" #visualObjectContainer>
  <div class="visual-object-margin image-decoration decoration" [class.border-style]="!showTitle" [style.max-width.%]="'100'" >
    <gridview>
      <gridview-header *ngIf="showTitle" classes="decoration-header flex-nowrap">
        <header-columntemplate size="auto" classes="header-image">
          <co-image width="24" height="24" type="svg" key="image" [imageSet]="imageSet"></co-image>
        </header-columntemplate>
        <header-columntemplate classes="header-title">
          {{decoration.title}}
        </header-columntemplate>
      </gridview-header>
      <gridview-row classes="py-2">
        <columntemplate>
          <co-image isVault="true" key="{{confImageValue.value}}" [width]="'auto'"></co-image>
        </columntemplate>
      </gridview-row>
    </gridview>
  </div>
</div>